/* eslint-disable */
import {
  Box,
  Button,
  Grid,
  LinearProgress,
  TextField,
  Typography,
  Tooltip,
  Paper,
  Autocomplete,
} from "@mui/material";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { useEffect, useState } from "react";
import Message from "../../../utils/Message";
import {
  getPersonaById,
} from "../../../services/PersonaJuridicaService";
import { useNavigate, useParams } from "react-router-dom";
import { KeyboardReturn, Save, Visibility } from "@mui/icons-material";
import { useLocation } from 'react-router-dom';
import DocumentosDialog from "../Dialogs/DocumentosDialog";
import TelefonosDialog from "../Dialogs/TelefonosDialog";
import ProfesionesDialog from "../Dialogs/ProfesionesDialog";
import DomiciliosDialog from "../Dialogs/DomiciliosDialog";
import AddIcon from '@mui/icons-material/Add';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";


const initialSearchData = {
  id: null,
  razon_social: "",
  cuit: "",
  email: "",
  numero_inscripcion: "",
  tipo_societario: "",
  fecha_contrato_social: null,
  domicilios: "",
  telefonos: "",
};

let nameItemsText = "";

//
// #############################################################################
//
const PersonaJuridica = () => {
  const [searchData, setSearchData] = useState(initialSearchData);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [Personas, setPersona] = useState([]);
  const [Personaselected, setPersonaelected] = useState([]);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [totalRowsCount, setTotalRowsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [valueAutoCompleteMedioDeCobro, setValueAutoCompleteMedioDeCobro] =
    useState({ id: "", label: "" });
  const [
    inputValueAutoCompleteMedioDeCobro,
    setInputValueAutoCompleteMedioDeCobro,
  ] = useState("");
  const [tipoMovimiento, setTipoMovimiento] = useState("todos");
  const [disabledtipoMovimiento, setDisabledtipoMovimiento] = useState(false);
  const [valueAutoCompleteObraSocial, setValueAutoCompleteObraSocial] = useState(
    { id: "", descripcion: "" });
  const [inputValueAutoCompleteObraSocial, setInputValueAutoCompleteObraSocial] = useState("");
  const [valueAutoCompleteObraSocialPlan, setValueAutoCompleteObraSocialPlan] = useState({
    id: "",
    descripcion_obra_social_plan: "",
    id_obra_social: ""
  })
  const [inputValueAutoCompleteObraSocialPlan, setInputValueAutoCompleteObraSocialPlan] = useState("");
  const [obraSocialPlanesTmp, setObraSocialPlanesTmp] = useState([]);
  const params = useParams();
  const [itemCrud, setItemCrud] = useState({});
  const [actionCrud, setActionCrud] = useState("");
  const [codigoPersona, setCodigoPersona] = useState('')
  const [estadoPersona, setEstadoPersona] = useState('')
  const navigate = useNavigate();
  const location = useLocation();
  const _idPersona = params.id;
  const _action = params.action;
  const { state } = location;
  const [openDocumentosDialog, setOpenDocumentosDialog] = useState(false);
  const [openTelefonosDialog, setOpenTelefonosDialog] = useState(false);
  const [openProfesionesDialog, setOpenProfesionesDialog] = useState(false);
  const [openDomiciliosDialog, setOpenDomiciliosDialog] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);



  const capitalizar = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  //
  // ################################################################################
  //
  const seleccionarPersona = (currentRowsSelected, allRowsSelected, rowsSelected) => {
    setPersonaelected(rowsSelected);
  }

  //
  // ################################################################################ 
  //
  const handleChange = (e) => {
    setSearchData({
      ...searchData,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };

  //
  // ################################################################################
  //
  const handleLimpiar = () => {
    setSearchData(initialSearchData);
    setValueAutoCompleteMedioDeCobro({ id: "", label: "" });
    setInputValueAutoCompleteMedioDeCobro("");
    setTotalRowsCount(0);
    setPersona([]);
    setPersonaelected([])
    setTipoMovimiento("todos");
  };


  const handleVolver = () => {
    navigate('/personas/persona-juridica-table')
  };


  //
  // ################################################################################
  //
  const handleBuscar = async () => {
    load(_idPersona);
  };

  //
  // ################################################################################
  //
  const load = async (idPersona) => {
    setIsDoingSomething(true);
    const response = await getPersonaById(idPersona)
    setIsDoingSomething(false);

    if (response.ok) {
      let _persona = response.data.data;


      if (_persona.razon_social) {
        _persona.razon_social = _persona.razon_social
      }

      if (_persona.tipo_societario) {
        _persona.tipo_societario = _persona.tipo_societario
      }

      if (_persona.cuit) {
        _persona.cuit = _persona.cuit
      }

      if (_persona.email) {
        _persona.email = _persona.email
      }

      if (_persona.numero_inscripcion) {
        _persona.numero_inscripcion = _persona.numero_inscripcion
      }

      if (_persona.fecha_contrato_social) {
        // dar formato a la fecha de dd-mm-yyyy con 2 digitos para el dia y mes y 4 digitos para el año
        let _fecha = new Date(_persona.fecha_contrato_social)
        let _dia = _fecha.getDate().toString().padStart(2, '0')
        let _mes = (_fecha.getMonth() + 1).toString().padStart(2, '0')
        let _anio = _fecha.getFullYear()
        _persona.fecha_contrato_social = _dia + '-' + _mes + '-' + _anio
      }

      if (_persona.domicilios && _persona.domicilios.length > 0) {
        setSearchData({
          ...searchData,
          domicilios: _persona.domicilios.length, domicilio: _persona.domicilios[0].descripcion,  // domicilio
        });
      }

      if (_persona.telefonos && _persona.telefonos.length > 0) {
        setSearchData({
          ...searchData,
          telefonos: _persona.telefonos.length, telefono: _persona.telefonos[0].numero,  // telefono
        });
      } else {
        setSearchData({
          ...searchData,
          telefonos: 0, telefono: '',  // telefono  
        });
      }


      setSearchData(_persona);

    }
    else {
      setMessage({
        severity: response.messageSeverity,
        messageText: response.messageText,
      });
      setShowMessage(true);
    }

  }

  //
  // ################################################################################
  // cuando se carga el componente
  //
  useEffect(() => {
    if (_action === 'view') {
      nameItemsText = "Ver Persona Jurídica";
    } else
      if (_action === 'edit') {
        nameItemsText = "Editar Persona Jurídica";
      }
    load(_idPersona)

  }, [currentPage, rowsPerPage]);


  useEffect(() => {
    let _codigoPersona = sessionStorage.getItem('codigoPersona');
    let _estadoPersona = sessionStorage.getItem('estadoPersona');
    if (_codigoPersona) {
      setCodigoPersona(_codigoPersona)
    }
    if (_estadoPersona) {
      setEstadoPersona(_estadoPersona)
    }
  }, []);

  // 
  // ################################################################################
  //
  useEffect(() => {
    setValueAutoCompleteObraSocial({
      id: searchData.obraSocial,
      descripcion: searchData.descripcionObraSocial,
    });
    setValueAutoCompleteObraSocialPlan({
      id: searchData.obraSocialPlan,
      descripcion_obra_social_plan: searchData.descripcionObraSocialPlan,
      id_obra_social: searchData.obraSocial,
    });
    let _codigoPersona = sessionStorage.getItem('codigoPersona');
    let _estadoPersona = sessionStorage.getItem('estadoPersona');
    if (_codigoPersona) {
      setCodigoPersona(_codigoPersona)
    }
    if (_estadoPersona) {
      setEstadoPersona((_estadoPersona).toUpperCase())
    }

  }, [])

  //
  // ################################################################################
  //manejo de los Apertura dialogos de documentos, telefonos, profesiones y domicilios

  const handleDocumentosDialog = () => {
    setOpenDocumentosDialog(true);
    setItemCrud(searchData.documentos)
    setActionCrud('view')
  }
  const handleTelefonosDialog = () => {
    setOpenTelefonosDialog(true);
    setItemCrud(searchData.telefonos)
    setActionCrud('view')

  }
  const handleProfesionesDialog = () => {
    setOpenProfesionesDialog(true);
    setItemCrud(searchData.profesiones)
    setActionCrud('view')


  }
  const handleDomiciliosDialog = () => {
    setOpenDomiciliosDialog(true);
    setItemCrud(searchData.domicilios)
    setActionCrud('view')

  }

  //
  // ################################################################################
  // manejo de los Apertura dialogos de documentos, telefonos, profesiones y domicilios
  const handleCloseDocumentosDialog = () => {
    setOpenDocumentosDialog(false);
  };
  const handleCloseTelefonosDialog = () => {
    setOpenTelefonosDialog(false);
  }
  const handleCloseProfesionesDialog = () => {
    setOpenProfesionesDialog(false);
  }
  const handleCloseDomiciliosDialog = () => {
    setOpenDomiciliosDialog(false);
  }

  //
  // ################################################################################
  // 


  return (
    <Box sx={{ flexGrow: 1, p: 4 }}>
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: '800px',
          maxHeight: '100%',
          width: '100%',
          m: 'auto',
          boxSizing: 'border-box',
          // backgroundColor: grey[100]
          backgroundColor: '#f0f0f1'

        }}
      >
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Box display="flex" justifyContent="center" alignItems="center" sx={{ mb: 2, mt: 3 }}>
              <Typography variant="h4" gutterBottom>
                {searchData.nameItemsText || 'Persona Jurídica'}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="center" alignItems="center" sx={{ mb: 2 }}>
              <Typography variant="h5" gutterBottom>
                {searchData.razon_social && searchData.razon_social ? (searchData.razon_social).toUpperCase() : ''}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} lg={6}>
            <TextField
              fullWidth
              label="Razón Social"
              variant="outlined"
              size="small"
              name="razon_social"
              value={searchData.razon_social?.toUpperCase() || ''}
              onChange={handleChange}
              InputProps={{ readOnly: _action === 'view', autoComplete: 'off' }}
            />
          </Grid>

          <Grid item xs={12} sm={6} lg={6}>
            <TextField
              fullWidth
              label="CUIT"
              variant="outlined"
              size="small"
              name="cuit"
              value={searchData.cuit || ''}
              onChange={handleChange}
              InputProps={{ readOnly: _action === 'view' }}
            />
          </Grid>

          {/* Fecha de Nacimiento */}
          <Grid item xs={12} sm={6} lg={6}>
            <DatePicker
              sx={{
                width: "100%",
                mb: 1,
                '& .MuiInputLabel-root': {
                  transform: 'translate(14px, 9px) scale(1)',
                },
                '& .MuiInputBase-root': {
                  paddingRight: '10px',
                },
                '& .MuiInputLabel-shrink': {
                  transform: 'translate(14px, -8px) scale(0.75)',
                },
              }}
              inputProps={{
                autoComplete: "off",
                readOnly: _action === 'view'
              }}
              label="Fecha de Contrato Social"
              value={selectedDate}
              disabled={_action === 'view'}
              onChange={(newValue) => {
                setSelectedDate(newValue);
                handleChange({ target: { name: 'fecha_nacimiento', value: newValue } });
              }}
              maxDate={new Date()}
              disableFuture
              renderInput={(params) => <TextField {...params} fullWidth size="small" />}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={6}>
            <TextField
              sx={{ width: "100%" }}
              inputProps={{
                autoComplete: "off",
                readOnly: _action === 'view'
              }}
              id="email"
              label="Correo Electrónico"
              variant="outlined"
              size="small"
              name="email"
              value={searchData.email ? searchData.email : ' '}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} sm={6} lg={6}>
            <Button
              fullWidth
              variant="contained"
              size="large"
              onClick={handleTelefonosDialog}
              disabled={searchData.telefonos?.length === 0 && _action === 'view'}
              startIcon={searchData.telefonos?.length === 0 ? <AddIcon /> : <VisibilityIcon />}
            >
              {searchData.telefonos?.length === 0 ? 'Agregar Teléfonos' : 'Ver Teléfonos'}
            </Button>
          </Grid>

          <Grid item xs={12} sm={6} lg={6}>
            <Button
              fullWidth
              variant="contained"
              size="large"
              onClick={handleDomiciliosDialog}
              disabled={searchData.domicilios?.length === 0 && _action === 'view'}
              startIcon={searchData.domicilios?.length === 0 ? <AddIcon /> : <VisibilityIcon />}
            >
              {searchData.domicilios?.length === 0 ? 'Agregar Domicilios' : 'Ver Domicilios'}
            </Button>
          </Grid>

          {searchData.fecha_actualizacion && (

            <Grid item xs={12} md={6} lg={6}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                  readOnly: _action === 'view'
                }}
                id="fecha_actualizacion"
                label="Fecha de Actualización"
                variant="outlined"
                size="small"
                name="fecha_actualizacion"
                value={searchData.fecha_actualizacion ? searchData.fecha_actualizacion : ' '}
                onChange={handleChange}
              />
            </Grid>
          )}
          {
            searchData.fecha_fallecimiento && (
              <Grid item xs={12} md={6} lg={6}  >
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                    readOnly: _action === 'view'
                  }}
                  id="fecha_fallecimiento"
                  label="Fecha de Fallecimiento"
                  variant="outlined"
                  size="small"
                  name="fecha_fallecimiento"
                  value={searchData.fecha_fallecimiento ? searchData.fecha_fallecimiento : ' '}
                  onChange={handleChange}
                />
              </Grid>
            )

          }
        </Grid>
        <Grid container spacing={1} sx={{ mt: 4, justifyContent: "flex-end" }}>
          {_action === 'edit' && (
            <Grid item xs={12} md={2} lg={2}>
              <Button
                sx={{ mr: 1, width: "100%" }}
                variant="outlined"
                onClick={handleLimpiar}
                startIcon={<CleaningServicesIcon />}
              >
                Limpiar
              </Button>
            </Grid>)}
          <Grid item xs={12} md={2} lg={3}>
            <Button
              sx={{ width: "100%", mt: 4 }}
              variant="outlined"
              onClick={handleVolver}
              startIcon={<KeyboardReturn />}
            >
              Volver
            </Button>
          </Grid>
          {_action !== 'view' && (

            <Grid item xs={12} md={6} lg={6}>
              <Button
                sx={{ mr: 1, width: "100%" }}
                variant="contained"
                onClick={handleSave}
                startIcon={<Save />}
                disabled={!searchData.nombre || !searchData.apellido || !searchData.sexo_registrado_nacimiento || !searchData.documentos || !searchData.fecha_nacimiento}
              >
                Guardar 
              </Button>
            </Grid>)}
        </Grid>
      </Paper>

      {/* dialogo de Documentos */}
      {
        openDocumentosDialog && (
          <DocumentosDialog
            onSave={handleDocumentosDialog}
            onClose={handleCloseDocumentosDialog}
            itemCrud={itemCrud}
            itemsCrud={searchData.documentos}
            actionCrud={actionCrud}
            setMessage={setMessage}
            setShowMessage={setShowMessage}
            _idPersona={_idPersona}
          />
        )
      }

      {/* dialogo de Telefonos */}
      {
        openTelefonosDialog && (
          <TelefonosDialog
            onSave={handleTelefonosDialog}
            onClose={handleCloseTelefonosDialog}
            itemCrud={itemCrud}
            itemsCrud={searchData.telefonos}
            actionCrud={actionCrud}
            setMessage={setMessage}
            setShowMessage={setShowMessage}
            _idPersona={_idPersona}
          />
        )
      }

      {/* dialogo de Profesiones */}
      {
        openProfesionesDialog && (
          <ProfesionesDialog
            onSave={handleProfesionesDialog}
            onClose={handleCloseProfesionesDialog}
            itemCrud={itemCrud}
            itemsCrud={searchData.profesiones}
            actionCrud={actionCrud}
            setMessage={setMessage}
            setShowMessage={setShowMessage}
            _idPersona={_idPersona}
          />
        )
      }

      {/* dialogo de Domicilios */}
      {
        openDomiciliosDialog && (
          <DomiciliosDialog
            onSave={handleDomiciliosDialog}
            onClose={handleCloseDomiciliosDialog}
            itemCrud={itemCrud}
            itemsCrud={searchData.domicilios}
            actionCrud={actionCrud}
            setMessage={setMessage}
            setShowMessage={setShowMessage}
            _idPersona={_idPersona}
          />
        )
      }

      {/* >>>> Messages */}
      {
        showMessage && (
          <Message
            showMessage={showMessage}
            setShowMessage={setShowMessage}
            message={message}
          />
        )
      }

    </Box>
  );
};

export default PersonaJuridica;
